import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { CategorysContext } from '../../context/categorys'
import { PagesContext } from '../../context/pages'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`

const TableListPages = ({ data, structure }) => {
    const {getAllPages,pages,setShowModalEditPage,get,deletePage} = useContext(PagesContext)
    const {remove,setShowModalEdit,setModalEditValue,setModalEditValueId} = useContext(CategorysContext)
    useEffect(() => {
        getAllPages()
    },[])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {String(pages).length == 0

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        pages?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td onClick={() => {setShowModalEditPage(true);get(item.name_page)}}>#{item.id}</td>
                                    <td onClick={() => {setShowModalEditPage(true);get(item.name_page)}} data-toggle="modal"  data-target="">{item.name_page}</td>
                                    <td data-toggle="modal"  data-target="" onClick={() => {setShowModalEdit(true);setModalEditValue(item.name);setModalEditValueId(item.id);setShowModalEditPage(true);get(item.name_page)}}><Image src={editIcon}/></td>
                                    <td data-toggle="modal"  data-target="" onClick={() => deletePage(item.id)}> <Image src={deleteIcon}/></td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListPages